import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { FaFileCsv } from "react-icons/fa";
import api from "../../services/api";

class ExportCSVExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { value: "id", label: "ID" },
        { value: "beneficiario__nome", label: "Beneficiário" },
        { value: "beneficiario__cpf", label: "CPF do Beneficiário" },
        { value: "beneficiario__data_nascimento", label: "Data de Nascimento" },
        { value: "beneficiario__celular", label: "Celular" },
        { value: "beneficiario__email", label: "E-mail" },
        { value: "data", label: "Data" },
        { value: "plano__nome", label: "Plano" },
        { value: "finalizado", label: "Finalizado" },
        { value: "optin_data", label: "Optin Data" },
        { value: "optin_termo__nome", label: "Optin Termo" },
        { value: "optin_ip", label: "Optin IP" },
        { value: "option_termo_conteudo", label: "Conteúdo do Termo" },
        { value: "optin_data_laboratorio", label: "Optin Data Laboratório" },
        { value: "optin_ip_laboratorio", label: "Optin IP Laboratório" },
        { value: "optin_telefone", label: "Optin Telefone" },
        { value: "optin_telefone_chamada_id", label: "Optin Telefone Chamada ID" },
        { value: "uuid", label: "UUID" },
        { value: "servico_procedimento", label: "Serviço/Procedimento" },
        { value: "valor_atendimento", label: "Valor Atendimento" },
        { value: "status_aprovacao", label: "Status Aprovação" },
        { value: "pdf_termo_prestador", label: "PDF Termo Prestador" },
        { value: "lets_sign_documento_id", label: "Documento ID (Let's Sign)" },
        { value: "lets_sign_documento_url", label: "Documento URL (Let's Sign)" },
        { value: "lets_sign_documento_assinado_url", label: "Documento Assinado (Let's Sign)" },
        { value: "lets_sign_msg_erro", label: "Mensagem Erro (Let's Sign)" },
        { value: "lets_doc_status", label: "Status Documento (Let's Sign)" },
        { value: "lets_assinatura_status", label: "Status Assinatura (Let's Sign)" },
        { value: "lets_link_assinatura", label: "Link Assinatura (Let's Sign)" },
        { value: "termo_paciente_pdf_comprovante", label: "PDF Comprovante Termo Paciente" },
        { value: "termo_prestador_pdf_comprovante", label: "PDF Comprovante Termo Prestador" },
        { value: "pagamento_servico", label: "Pagamento Serviço" },
        { value: "pagamento_comprovante", label: "Pagamento Comprovante" },
        { value: "goto_connect_id", label: "Goto Connect ID" },
        { value: "tipo_atendimento", label: "Tipo Atendimento" },
        { value: "receptivo_nome", label: "Receptivo Nome" },
        { value: "receptivo_cpf", label: "Receptivo CPF" },
        { value: "receptivo_para_quem", label: "Receptivo Para Quem" },
        { value: "receptivo_email", label: "Receptivo E-mail" },
        { value: "receptivo_telefone", label: "Receptivo Telefone" },
        { value: "receptivo_texto", label: "Receptivo Texto" },
        { value: "programa__nome", label: "Programa" },
        { value: "etapa__nome", label: "Etapa" },
        { value: "cliente__nome", label: "Cliente" },
        { value: "laboratorio__nome", label: "Laboratório" },
        { value: "faturamento__nome", label: "Faturamento" },
        { value: "cancelado", label: "Cancelado" },
        { value: "data_cancelamento", label: "Data Cancelamento" },
        { value: "tipo_paciente", label: "Tipo Paciente" },
        //{ value: "twilio_retorno", label: "Twilio Retorno" },
        { value: "data_criacao", label: "Data Criação" },
        { value: "data_atualizacao", label: "Data Atualização" },
        { value: "doenca__nome", label: "Doença" },
        { value: "multiprofissional__nome", label: "Multiprofissional" },
        { value: "programa_status__nome", label: "Programa Status" },
        { value: "produto_descricao", label: "Produto Descrição" },
        { value: "medico_data_alteracao", label: "Médico Data Alteração" },
        { value: "optout_data", label: "Optout Data" },
        { value: "optout_motivo__nome", label: "Optout Motivo" },
        { value: "optout_motivo_outros", label: "Optout Motivo Outros" },
        { value: "doenca_outros", label: "Doença Outros" },
        { value: "atendimento_validado", label: "Atendimento Validado" },
        { value: "excluido", label: "Excluído" },
        { value: "termo_programa_pdf", label: "Termo Programa PDF" },
      ],
      // Seleção inicial (pode ser ajustada conforme sua necessidade)
      selectedColumns: [
        { value: "id", label: "ID" },
        { value: "beneficiario__nome", label: "Beneficiário" },
        { value: "data", label: "Data" },
      ],
      exportFormat: "csv",
      showModal: false,
      allFieldsChecked: false,
      exporting: false,
    };
  }

  handleAllFieldsToggle = () => {
    const { allFieldsChecked, columns } = this.state;
    this.setState({
      allFieldsChecked: !allFieldsChecked,
      selectedColumns: !allFieldsChecked ? columns : [],
    });
  };

  toggleModal = () => {
    this.setState((prevState) => ({ showModal: !prevState.showModal }));
  };

  handleExport = async () => {
    const { selectedColumns, exportFormat, exporting } = this.state;

    if (selectedColumns.length === 0) {
      alert("Por favor, selecione ao menos uma coluna.");
      return;
    }

    if (exporting) {
      return;
    }

    const selectedValues = selectedColumns.map((col) => col.value);

    // filtros ativos da listagem, para o CSV/Excel refletir exatamente a tela
    const filtros =
      typeof this.props.getFiltros === "function" ? this.props.getFiltros() : {};

    this.setState({ exporting: true });

    try {
      const response = await api.post(
        "/export-atendimentos-data/",
        { ...filtros, columns: selectedValues, format: exportFormat },
        { responseType: "blob" }
      );

      const fileName =
        exportFormat === "csv"
          ? "relatorio de atendimentos.csv"
          : "relatorio de atendimentos.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      this.toggleModal();
    } catch (error) {
      console.error(`Erro ao exportar ${exportFormat.toUpperCase()}:`, error);
      alert(`Não foi possível exportar ${exportFormat.toUpperCase()}. Tente novamente.`);
    } finally {
      this.setState({ exporting: false });
    }
  };

  render() {
    const { showModal, columns, selectedColumns, exportFormat, exporting } = this.state;

    return (
      <>
        <Button variant="light" size="sm" onClick={this.toggleModal} disabled={exporting}>
          <FaFileCsv /> Exportar CSV/Excel
        </Button>

        <Modal show={showModal} onHide={exporting ? undefined : this.toggleModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Exportar CSV/Excel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Selecione as colunas que deseja incluir no relatório:</p>
            <div className="mb-3">
              <input
                type="checkbox"
                id="all-fields"
                checked={this.state.allFieldsChecked}
                disabled={exporting}
                onChange={this.handleAllFieldsToggle}
              />
              <label htmlFor="all-fields" className="ms-2">
                Todos os campos
              </label>
            </div>
            <Select
              options={columns}
              isMulti
              isDisabled={exporting}
              onChange={(selected) =>
                this.setState({
                  selectedColumns: selected,
                  allFieldsChecked: false,
                })
              }
              value={selectedColumns}
              placeholder="Selecione as colunas"
              className="mb-3"
            />
            <Form>
              <Form.Group>
                <Form.Label>Formato de Exportação</Form.Label>
                <Form.Check
                  type="radio"
                  label="CSV"
                  name="exportFormat"
                  value="csv"
                  checked={exportFormat === "csv"}
                  disabled={exporting}
                  onChange={(e) =>
                    this.setState({ exportFormat: e.target.value })
                  }
                />
                <Form.Check
                  type="radio"
                  label="Excel"
                  name="exportFormat"
                  value="excel"
                  checked={exportFormat === "excel"}
                  disabled={exporting}
                  onChange={(e) =>
                    this.setState({ exportFormat: e.target.value })
                  }
                />
              </Form.Group>
            </Form>
            {exporting && (
              <p className="text-muted small mb-0 mt-3">
                Preparando a exportação. Em relatórios com muitos registros isso
                pode levar alguns minutos — por favor, aguarde e não feche esta
                janela.
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.toggleModal} disabled={exporting}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={this.handleExport} disabled={exporting}>
              {exporting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Exportando...
                </>
              ) : (
                "Exportar"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

ExportCSVExcel.propTypes = {
  getFiltros: PropTypes.func,
};

export default ExportCSVExcel;
